import type { Store } from 'effector'

import { combine, createEvent, sample } from 'effector'
import { and, not } from 'patronum'
import { model as i18n } from '~/core/i18n'
import { register } from '~/core/repository'
import { model as router } from '~/core/router'
import { entityPartnerProductGridModel } from '~/entities/partner-product/grid'
import '~/entities/shows/model'
import { featureSubscriberPartnerProgramModel } from '~/features/subscriber/partner-program'

const DEFAULT_GRID_ELEMENTS_COUNT = 36

export const init = createEvent()
export const left = createEvent()

// navigate to home if partners program is not enabled
sample({
  clock: init,
  filter: not(featureSubscriberPartnerProgramModel.$partnersProgramEnabled),
  fn: () => '/',
  target: router.navigatePush,
})

sample({
  clock: init,
  filter: and(
    not(entityPartnerProductGridModel.$partnerProductGridLoading),
    featureSubscriberPartnerProgramModel.$partnersProgramEnabled
  ),
  fn: () => ({ page: 0, count: DEFAULT_GRID_ELEMENTS_COUNT }),
  target: entityPartnerProductGridModel.loadPartnerProductGrid,
})

sample({
  clock: left,
  filter: featureSubscriberPartnerProgramModel.$partnersProgramEnabled,
  target: entityPartnerProductGridModel.resetPartnerProductGrid,
})

export const $partnerProductRowTitle: Store<string> = combine(
  i18n.$t,
  ({ t }) => t('partner_products')
)

register(
  entityPartnerProductGridModel.$partnerProductGridFormatted,
  '$partnerProgram/grid/partnerProductGridFormatted'
)
register($partnerProductRowTitle, '$partnerProductGridTitle')
register(
  entityPartnerProductGridModel.loadMorePartnerProductGrid,
  'loadMorePartnerProductGrid'
)
